import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { type HighlightMaterial } from '@meitu/saas-editor-core/es/framework/services/text-highlight';
import { type ArtTextStruct } from '@meitu/saas-editor-ui';
import { type FontMaterialRaw } from '@meitu/xdesign-widgets';
import { type ListStyleStruct } from '@/services/text/types';

/** 分别维护面板可选字体与引擎回退字体，以及设计师编辑器的文字素材 */
export type IFontMaterialModel = {
    fonts: FontMaterialRaw[];
    /** 供文本引擎和文件解析器使用的回退字体，不展示在字体面板中 */
    fallbackFonts: FontMaterialRaw[];
    /**
     * 同步更新面板与解析器依赖的字体目录，并写入字体素材 store
     * @param payload - 当前应用允许选择的字体
     * @param fallbackFonts - 从完整目录补齐的回退字体
     */
    setFonts: (payload: FontMaterialRaw[], fallbackFonts?: FontMaterialRaw[]) => void;

    listStyles: ListStyleStruct[];
    setListStyles: (payload: ListStyleStruct[]) => void;

    artTexts: ArtTextStruct[];
    setArtTexts: (payload: ArtTextStruct[]) => void;

    highlights: HighlightMaterial[];
    setHighlights: (payload: HighlightMaterial[]) => void;
};

const useFontMaterialModel = create<IFontMaterialModel>()(
    immer((set) => ({
        fonts: [],
        fallbackFonts: [],
        setFonts: (payload, fallbackFonts = []) =>
            set((state) => {
                state.fonts = payload;
                state.fallbackFonts = fallbackFonts;
            }),

        listStyles: [],
        setListStyles: (payload) =>
            set((state) => {
                state.listStyles = payload;
            }),

        artTexts: [],
        setArtTexts: (payload) =>
            set((state) => {
                state.artTexts = payload;
            }),

        highlights: [],
        setHighlights: (payload) =>
            set((state) => {
                state.highlights = payload;
            }),
    })),
);

export { useFontMaterialModel };
export const getFontMaterialModel = () => useFontMaterialModel.getState();
